module.exports = __webpack_public_path__ + "img/B2.5e65093e.png";